/**
 * Throttle function to avoid calling functions too many times unnecessarily
 */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last,
      deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date,
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

function slickInit(ele, dots, arrows) {
  /**
   * Auto-slick everything. Force all slides to have the same height
   */
  ele.slick({
    dots: dots,
    infinite: true,
    speed: 250,
    // Use autoplay
    autoplay: true,
    autoplaySpeed: 8000,
    // The auto pauses mess up the manual one when video is open
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    // Render arrows
    arrows: arrows,
    // Custom arrow html
    prevArrow: '<a href="javascript:void(0)" class="slick-prev icon-arrow"></a>',
    nextArrow: '<a href="javascript:void(0)" class="slick-next icon-arrow"></a>',
    appendArrows: ele.parent(), // .slick has overflow hidden and they
    // need to be outside of it, so we append the arrows to the parent.
  }).each(function() {
    /**
     * Force same height to all slides
     */
    function equalizeHeights() {
      var $this = $(this);
      var $track = $this.find('.slick-track');
      var $slides = $track.children();
      // Layout thrashing here, can't help it since we need to remove
      // min-height to have the layout recalculate the auto height of the
      // slick track
      $slides.css('min-height', '');
      var minSlideHeight = $track.height();
      $slides.css('min-height', minSlideHeight);
    }
    // Bind the equalize heights function to each slick, so the this variable
    // has the correct element each time the function is called.
    // Throttle the function so that it is only ran twice a second
    /**
     * "The bind() method creates a new function that, when called, has its this
     * keyword set to the provided value, with a given sequence of arguments
     * preceding any provided when the new function is called."
     */
    var equalizeSlideHeights = throttle(equalizeHeights.bind(this), 500, true);
    // Then add the function to the load and resize events
    $(window).on('DOMContentLoaded load resize', equalizeSlideHeights);
  });
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
  }
  return "";
}

$(document).ready(function() {
  if ($('.globalcartbtn').length) {
    $('.title.full-width').removeClass('full-width');
    $('.globalcartbtn').appendTo('.add-to-cart');
  }
  $('[role="tablist"]').click(function (e) {
    e.preventDefault();
    $(this).tab('show');
  })

  // Clear quantity input text
  $('[name=var_quantity].input-text.qty.text').on('click', function() {
    if ($(this).val() == 0) {
      $(this).val('');
    }
  }).on('focusout', function() {
    if ($(this).val() == '') {
      $(this).val(0);
    }
  });

  // Tab content scroll without scrolling page
  $('.tab-content').on('mouseover', function() {
    if ($(this).height() > 275) {
      $('body').css('overflow', 'hidden');
    }
  }).on('mouseout', function() {
    $('body').css('overflow', 'auto');
  });
})
